/**
 * Safari can emit Ctrl + primary-click as a contextual (secondary) click.
 */
export function isSecondaryClick(
  event: Pick<MouseEvent, 'button' | 'ctrlKey'>
) {
  return event.button === 2 || (event.button === 0 && event.ctrlKey)
}
